<template>
	<div
		:class="
			cn(
				'typography-c2-reg inline-flex min-w-[16px] items-center justify-center rounded-[12px] bg-o-600 px-4px text-white',
				{ 'min-w-[20px] py-[2px]': size === 'md' },
				props.class,
			)
		"
	>
		{{ displayedCount }}
	</div>
</template>

<script setup lang="ts">
import { type PropType, computed } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps({
	size: {
		type: String as PropType<'sm' | 'md'>,
		default: 'md',
	},
	count: {
		type: Number,
		required: true,
	},
	maxCount: {
		type: Number,
		default: 99,
	},
	class: {
		type: String,
		default: '',
	},
})

const displayedCount = computed(() =>
	props.count > props.maxCount ? `${props.maxCount}+` : props.count,
)
</script>
